// extracted by mini-css-extract-plugin
module.exports = {"footerDiv":"FinalTests_footerDiv__3oAPN","PageNumberDiv":"FinalTests_PageNumberDiv__2HyX9","ArrowButton":"FinalTests_ArrowButton__2mxNh","InputPage":"FinalTests_InputPage__W0Lo7"};